import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="auto-logout"
export default class extends Controller {
  static targets = ["modal", "countdown"];
  static values = {
    timeout: Number, // Timeout value in milliseconds
  };

  connect() {
    this.isShowingWarning = false;
    this.setTimer();
    this.startListening();
  }

  disconnect() {
    this.stopListening();
    this.clearTimer();
  }

  startListening() {
    ["mousemove", "keydown", "scroll", "click"].forEach((event) => {
      document.addEventListener(event, this.resetTimer);
    });
  }

  stopListening() {
    ["mousemove", "keydown", "scroll", "click"].forEach((event) => {
      document.removeEventListener(event, this.resetTimer);
    });
  }

  setTimer() {
    this.clearTimer();
    this.timer = setTimeout(this.showWarning, this.timeoutValue);
  }

  clearTimer() {
    if (this.timer) clearTimeout(this.timer);
    if (this.warningTimer) clearTimeout(this.warningTimer);
    if (this.countdownInterval) clearInterval(this.countdownInterval);
  }

  resetTimer = () => {
    if (this.isShowingWarning) return;
    const now = Date.now();
    if (this._lastReset && now - this._lastReset < 10_000) return;
    this._lastReset = now;
    this.setTimer();
  };

  showWarning = () => {
    // Idempotent: clear prior state before setting new state
    if (this.warningTimer) clearTimeout(this.warningTimer);
    if (this.countdownInterval) clearInterval(this.countdownInterval);

    this.isShowingWarning = true;
    this.modalTarget.classList.remove("hidden");

    this.remainingTime = 60;
    this.updateCountdown();
    this.countdownInterval = setInterval(this.updateCountdown, 1000);

    this.warningTimer = setTimeout(this.logout, 60_000);
  };

  stayLoggedIn = () => {
    this.modalTarget.classList.add("hidden");
    this.isShowingWarning = false;
    this.setTimer();
  };

  updateCountdown = () => {
    this.countdownTarget.textContent = this.remainingTime;
    this.remainingTime -= 1;

    if (this.remainingTime < 0) {
      clearInterval(this.countdownInterval);
    }
  };

  logout = async () => {
    try {
      const sessionId = document
        .querySelector('meta[name="active-session-id"]')
        ?.getAttribute("content");
      const csrfToken = document
        .querySelector('meta[name="csrf-token"]')
        ?.getAttribute("content");

      if (sessionId && csrfToken) {
        await fetch(`/logout?id=${sessionId}`, {
          method: "DELETE",
          headers: { "X-CSRF-Token": csrfToken },
        });
      }
    } catch {
      // Network failure — session will expire server-side
    }

    window.location.href = "/login";
  };
}
